import { HttpErrorResponse } from "@angular/common/http";

/**
 * Whether a failed entity lookup means "this record does not exist" (answer 404)
 * rather than "the backend is unwell" (answer 503).
 *
 * ⚠️ INTERIM — 500 is deliberately treated as not-found (SIIL-6166).
 *
 * The CMS itself is correct: `ProductController`/`SolutionController` in
 * `siila-content-management` return 404 when the record is missing. But the
 * `/api/content/**` layer that sits in front of them converts that 404 into a
 * 500 before it reaches this app, so a 500 here is indistinguishable from a
 * missing record. Without this mapping the detail routes cannot answer 404 at
 * all, which is the defect the ticket exists to fix.
 *
 * The cost of the mapping: while it stands, a genuine backend outage answers
 * 404 on product/solution detail pages instead of 503, which Google may read as
 * "these pages are gone". Accepted knowingly as the smaller risk against
 * Prerender.io caching non-existent pages as valid 200s.
 *
 * REMOVE the `500` arm once the `/api/content/**` layer propagates the CMS's
 * real 404 — tracked in the siila-content-management repo at
 * `kkpa/plans/seo/product-solution-not-found-contract-2026-08-04.md`. After
 * that, a 500 belongs on the 503 branch with every other server fault.
 *
 * A timeout rejection carries no `status`, so it correctly falls through to the
 * 503 branch.
 */
export function isMissingEntity(err: HttpErrorResponse): boolean {
  return err && (err.status === 404 || err.status === 500);
}
